import { observer } from "mobx-react";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import React, { useEffect } from "react";
import { MenuItemModifierSet } from "../../../services/menu/models";
import { useStores } from "../../../hooks";
import useModifiersSetsSearch from "../../../hooks/searchModifiersSets";
import { MenuFormType } from "../../../modules/menu/store/menu/forms";
import { TextField } from "../libs";
import { localize } from "../../libs";
import { useTranslation } from "react-i18next";
import { ModifiersFormType } from "../../../modules/menu/store/modifiersSets/forms";


const filter = createFilterOptions<MenuItemModifierSet>();

interface Props {
    setModifierSetId: (v: number) => void;
    additionalValues: MenuItemModifierSet[],
    modifierSetId: number | null,
    style?: any
}

const ModifiersSetsAutocomplete = ({setModifierSetId, additionalValues, modifierSetId, style}: Props) => {
    const {t} = useTranslation(["general", "menu"]);
    const {modifiersSetsStore} = useStores();
    const [modifiersSetsSuggestions, setQuery] = useModifiersSetsSearch();


    useEffect(() => {
        (async () => {
            await modifiersSetsStore.ensureLoaded();
            setQuery("");
        })()
    }, [modifiersSetsStore, modifiersSetsStore.modifiersSets.length]);


    let styles = style || {};

    return <Autocomplete
        getOptionSelected={(option, value) => {
            //@ts-ignore
            return option.id === value
        }}
        //@ts-ignore
        value={modifierSetId}
        clearOnBlur
        onChange={(event, newValue) => {
            if (typeof newValue == "string") {
                //@ts-ignore
            } else if (newValue && newValue.inputValue) {
                modifiersSetsStore.forms.setModifiersSetInitDataAndNotify({
                    //@ts-ignore
                    name: newValue.inputValue
                }, setModifierSetId);
                modifiersSetsStore.forms.showPopupForm(ModifiersFormType.editMenuModifiersSet);
            } else if (newValue) {
                //@ts-ignore
                setModifierSetId(newValue.id);
            }else{
                console.log(newValue)
            }
        }}
        filterOptions={(options, params) => {
            //@ts-ignore
            const filtered = filter(options, params);

            // Suggest the creation of a new value
            if (params.inputValue !== '') {
                filtered.push({
                    //@ts-ignore
                    inputValue: params.inputValue,
                    title: `${t("menu:common.addModifierSet")} "${params.inputValue}"`,
                });
            }
            return filtered;
        }}
        onInputChange={(e, value: string) => {
            setQuery(value);
        }}
        handleHomeEndKeys
        id="free-solo-with-text-demo"
        options={[...modifiersSetsSuggestions, ...additionalValues].filter(item => !!item)}
        getOptionLabel={(option) => {

            // Value selected with enter, right from the input
            if (typeof option === 'string') {
                return option;
            }
            // Add "xxx" option created dynamically
            //@ts-ignore
            if (option.inputValue) {
                //@ts-ignore
                return option.title;
            }

            if(typeof option === "number"){
                const modifiersSet = modifiersSetsStore.getModifiersSetById(option);
                if(!modifiersSet) return `${option}`;
                return localize(modifiersSet.data.name)
            }
            //@ts-ignore
            return localize(option.data.name);
        }}
        style={styles}
        renderInput={(params) => (
            <TextField {...params} label={t("menu:common.modifierSet")} variant="outlined"/>
        )}
    />
};

export default observer(ModifiersSetsAutocomplete);
